

import Vue from "vue";
import {InboxState} from "@/utils/inbox/inbox-state";

export default Vue.extend({
	props: {
		state: {
			required: true,
			type: Object as () => InboxState
		},
	},
	computed: {
		previewText():string{
			let css = "<style>\n" +
				"        * {\n" +
				"          font-family: \"Open sans\", sans-serif !important;\n" +
				"          font-size: 14px;\n" +
				"        }\n" +
				"      </style>";
			return css + this.state.preview?.Text;
		}
	},
	methods: {},
	async created() {},
	components: {},
	i18nEx: {
		componentPrefix: "components.purchases"
	}
});
